import React from 'react';

const NacionalIcon = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1.5em'
      height='1.5em'
      viewBox='0 0 1200 1200'
      {...props}
    >
      <defs>
        <style>{'.cl1{fill:#fff; fill-rule:evenodd}'}</style>
      </defs>
      <path
        className='cl1 subheader__container-link-icon'
        d='m442.32 91.777c-7.6562 50.773-21.434 28.402-38.688 61.43-19.309 36.91 24.926 51.613 8.6992 82.738-20.699 39.707-35.723 72.637-50.473 134.12-6.9727 29.004 24.695 61.379 24 92.605-0.91016 41.23-32.965 93.227-17.473 139.86 6.5625 19.754-9.9492 149.82 20.027 207.18 24.086 46.055 8.6992 26.723-26.723 163.75-9.2891 35.965 29.426 38.207 29.641 39.086 15.758 64.008 81.793 34.957 81.707 34.777-9.9961-17.879-21.348-31.477-12.648-53.52 3.2773-8.3164 22.066-3.5391 23.832-12.312 14.102-70.297 62.352-40.68 39.023-90.973-20.27-43.668-55.285 10.02-1.6445-76.066 30.109-48.301 20.809-42.672 28.703-66.383 1.7773-5.3164 13.355-0.058594 16.105-4.957 3.5508-6.3125 6.1094-22.117-1.1406-21.719-32.531 1.7539-82.391-30.168-39.406-40.535 98.809-23.832 19.691-22.703 76.656-60.434 64.906-42.984 103.49-12.023 131.27-51 35.172-49.297-8.6172-19.621-3.8516-56.473 7.332-56.555-49.754 7.9805-26.641-93.938 26.566-117.06-3.5273-13.43 73.766-118.61 27.059-36.805 54.84-54.996 61.535-77.207 5.0508-16.727-7.5703-55.297-18.133-34.488-39.961 78.602-78.707 63.406-127.08 50.891-15.863-4.1055 39.574-50.965 31.066-64.871-34.766-56.844-48.984-3.5508-148.59-102.49-15.133-15.023-14.941-14.004-37.246-8.4844-9.707 2.3984-9.5508 17.594-15.254 25.789-0.46875 0.69531-1.7656 4.1641-2.3281 3.0117-18.516-38.316-10.68-20.652-54.383-28.668-12.133-2.1797-22.512 15.703-24.336 27.883zm77.219 1046c16.957 1.0195 15.469 6.3125 30.312-4.7383 5.9883-4.4648-70.008-47.531-70.008-47.531 1.8125 15.562-4.0312 34.223 5.4492 46.703 6.9961 9.1992 22.703 4.8945 34.246 5.5664z'
      />
    </svg>
  );
};

export default NacionalIcon;
